import React from "react";
import { object, func, string, bool } from "prop-types";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  FormGroup,
  FormLabel,
  FormControl,
} from "react-bootstrap";
import { format } from "date-fns";
import { accountForExistingTimeOffset } from "../../utils/helperFunctions";
import DatePickerInput from "../../components/DatePickInput";
import ClearDatesButton from "../../components/DatePickInput/ClearDatesButton";

export class SearchFilterModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        searchText: this.props.currentSearchText || null,
        jobTitle: this.props.searchFilters.get("jobTitle") || "",
        state: this.props.searchFilters.get("state") || "",
        city: this.props.searchFilters.get("city") || "",
        zipcode: this.props.searchFilters.get("zipcode") || "",
        country: this.props.searchFilters.get("country") || "",
        applicationFilterId:
          this.props.searchFilters.get("applicationFilterId") || "",
        applicationFilterType:
          this.props.searchFilters.get("applicationFilterType") || "",
        fromDate: this.props.searchFilters.get("fromDate") || "",
        toDate: this.props.searchFilters.get("toDate") || "",
        sourceId: this.props.searchFilters.get("sourceId") || "",
        eventStatus: this.props.searchFilters.get("eventStatus") || "",
        stageName: this.props.searchFilters.get("stageName")
          ? `${this.props.searchFilters
              .get("stageName")
              .charAt(0)
              .toUpperCase()}${this.props.searchFilters
              .get("stageName")
              .slice(1)}`
          : "",
        labelId: this.props.searchFilters.get("labelId") || "",
        ratingType: this.props.searchFilters.get("ratingType") || "",
        ratingValue: this.props.searchFilters.get("ratingValue") || "",
        testTakerId: this.props.searchFilters.get("testTakerId") || "",
      },
      locationSelected: "",
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.searchFilterOptions.get("ratings") !==
      nextProps.searchFilterOptions.get("ratings")
    ) {
      nextProps.searchFilterOptions.get("ratings").map((rating) => {
        // TODO: return the ratings array correctly from the endpoint
        if (
          nextProps.searchFilterOptions.get("ratings").get("ratingType") ===
          "stars"
        ) {
          this.setState({ starsRatingUsed: true });
        } else {
          if (rating.get("ratingType") === "stars") {
            this.setState({ starsRatingUsed: true });
          }
          if (rating.get("ratingType") === "thumbs") {
            this.setState({ thumbsRatingUsed: true });
          }
          if (rating.get("ratingType") === "ten") {
            this.setState({ tensRatingUsed: true });
          }
        }
        return true;
      });
    }
  }

  /* --------- Event Handlers ---------- */

  onHandleFilteredSearchSubmit = () => {
    this.props.handleFilteredSearchSubmit(this.state.formData);
  };

  handleSelection = (event) => {
    const field = event.target.id;

    const { value } = event.target;

    switch (field) {
      case "location": {
        this.setState({ locationSelected: value });
        const locationData = this.props.searchFilterOptions
          .get("locations")
          .get(String(value));
        if (locationData) {
          this.setState((prevState) => ({
            formData: {
              ...prevState.formData,
              city: locationData.get("city"),
              state: locationData.get("state"),
              zipcode: locationData.get("zipcode"),
              country: locationData.get("country"),
            },
          }));
        } else {
          this.setState((prevState) => ({
            formData: {
              ...prevState.formData,
              city: "",
              state: "",
              zipcode: "",
              country: "",
            },
          }));
        }
        break;
      }
      case "application":
        if (value === "") {
          this.setState((prevState) => ({
            formData: {
              ...prevState.formData,
              applicationFilterId: "",
              applicationFilterType: "",
            },
          }));
        } else {
          this.props.searchFilterOptions
            .get("applicationFilters")
            .map((filter) => {
              if (filter.get("applicationFilterId") === Number(value)) {
                this.setState(({ formData }) => ({
                  formData: {
                    ...formData,
                    applicationFilterId: filter.get("applicationFilterId"),
                    applicationFilterType: filter.get("applicationFilterType"),
                  },
                }));
              }
              return true;
            });
        }
        break;
      case "stageName":
        this.setState((prevState) => ({
          formData: {
            ...prevState.formData,
            [field]: value,
          },
        }));
        break;
      case "ratings":
        {
          const ratings = value.split("-");

          this.setState((prevState) => ({
            formData: {
              ...prevState.formData,
              ratingType: ratings[0],
              ratingValue: ratings[1],
            },
          }));
        }
        break;
      case "sources":
        {
          // we need to set the sourceName value here, so that it displays correctly in the header of the Search
          // Results page.

          let sourceName;
          this.props.searchFilterOptions.get("sources").map((source) => {
            if (source.get("sourceId") === Number(value)) {
              sourceName = source.get("sourceName");
            }
            return true;
          });
          this.setState((prevState) => ({
            formData: {
              ...prevState.formData,
              sourceId: value,
              sourceName,
            },
          }));
        }
        break;
      case "labels":
        this.setState((prevState) => ({
          formData: {
            ...prevState.formData,
            labelId: value,
          },
        }));
        break;
      default: {
        this.setState((prevState) => ({
          formData: {
            ...prevState.formData,
            [field]: value,
          },
        }));
      }
    }
  };

  handleFromDateChange = (day) => {
    const date = format(day, "yyyy-MM-dd");
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        fromDate: date,
      },
    }));
  };

  handleToDateChange = (day) => {
    const date = format(day, "yyyy-MM-dd");
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        toDate: date,
      },
    }));
  };

  handleSearchInput = (event) => {
    const searchText = event.target.value;
    this.setState(({ formData }) => ({
      formData: {
        ...formData,
        searchText,
      },
    }));
    this.props.onSetUserInput(["currentSearchText"], event.target.value);
  };

  handleTestTakerIdInput = (event) => {
    const testTakerId = event.target.value;

    this.setState(({ formData }) => ({
      formData: {
        ...formData,
        testTakerId,
      },
    }));
  };

  handleClearSearch = () => {
    this.setState({
      formData: {
        jobTitle: "",
        state: "",
        city: "",
        zipcode: "",
        country: "",
        applicationFilterId: "",
        applicationFilterType: "",
        fromDate: undefined,
        toDate: undefined,
        sourceId: "",
        eventStatus: "",
        stageName: "",
        labelId: "",
        ratingType: "",
        ratingValue: "",
        searchText: "",
      },
    });
    this.props.onResetSearchFilters();
  };

  hideSearchModal = () => {
    this.setState({
      formData: {
        jobTitle: "",
        state: "",
        city: "",
        zipcode: "",
        country: "",
        applicationFilterId: "",
        applicationFilterType: "",
        fromDate: undefined,
        toDate: undefined,
        sourceId: "",
        eventStatus: "",
        stageName: "",
        labelId: "",
        ratingType: "",
        ratingValue: "",
      },
      locationSelected: "",
    });
    this.props.hideSearchModal();
  };

  handleClearDates = () => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        fromDate: "",
        toDate: "",
      },
    }));
  };

  /*
   *
   * RENDER METHOD
   *
   */

  render() {
    // Props to Variables
    const { searchFilterOptions, isMobile } = this.props;

    /* ---------- Options for each Filter ---------- */

    const Titles =
      searchFilterOptions.size > 0
        ? searchFilterOptions
            .get("jobTitles")
            .sort((a, b) => a.localeCompare(b))
            .entrySeq()
            .map((job) => {
              const trimmedJob =
                job.length < 32 ? job[1] : `${job[1].substr(0, 32)} ...`;
              return (
                <option key={job[1]} value={job[1]}>
                  {trimmedJob}
                </option>
              );
            })
        : null;
    const Locations =
      searchFilterOptions.size > 0
        ? searchFilterOptions
            .get("locations")
            .entrySeq()
            .map((location) => {
              if (location) {
                return (
                  <option key={location[0]} value={location[0]}>
                    {location[1].get("city")}, {location[1].get("state")}
                    {location[1].get("country")
                      ? `, ${location[1].get("country")}`
                      : ""}
                  </option>
                );
              }
              return "";
            })
        : null;

    const ApplicationFilters =
      searchFilterOptions.size > 0
        ? searchFilterOptions
            .get("applicationFilters")
            .sort((a, b) =>
              a
                .get("applicationFilterName")
                .localeCompare(b.get("applicationFilterName"))
            )
            .entrySeq()
            .map((filter) => (
              <option
                key={filter[1].get("applicationFilterId")}
                value={filter[1].get("applicationFilterId")}
              >
                {filter[1].get("applicationFilterName").length < 32
                  ? filter[1].get("applicationFilterName")
                  : `${filter[1]
                      .get("applicationFilterName")
                      .substr(0, 32)} ...`}
              </option>
            ))
        : null;
    const Sources =
      searchFilterOptions.size > 0
        ? searchFilterOptions
            .get("sources")
            .sort((a, b) =>
              a.get("sourceName").localeCompare(b.get("sourceName"))
            )
            .entrySeq()
            .map((source) => (
              <option
                key={source[1].get("sourceId")}
                value={source[1].get("sourceId")}
              >
                {source[1].get("sourceName")}
              </option>
            ))
        : null;
    const Labels =
      searchFilterOptions.size > 0
        ? searchFilterOptions
            .get("labels")
            .sort((a, b) =>
              a.get("labelName").localeCompare(b.get("labelName"))
            )
            .entrySeq()
            .map((label) => (
              <option
                key={label[1].get("labelId")}
                value={label[1].get("labelId")}
              >
                {label[1].get("labelName")}
              </option>
            ))
        : null;
    const StarRatings = this.state.starsRatingUsed
      ? [
          { rating: 5, text: "5 Stars" },
          { rating: 4, text: "4 Stars or more" },
          { rating: 3, text: "3 Stars or more" },
          { rating: 2, text: "2 Stars or more" },
          { rating: 1, text: "1 Star or more" },
        ].map((rate) => (
          <option key={`star-${rate.rating}`} value={`stars-${rate.rating}`}>
            {rate.text}
          </option>
        ))
      : "";
    const ThumbsRatings = this.state.thumbsRatingUsed
      ? [
          { rating: 0.9, text: "90% Thumbs up or higher" },
          { rating: 0.8, text: "80% Thumbs up or higher" },
          { rating: 0.7, text: "70% Thumbs up or higher" },
          { rating: 0.6, text: "60% Thumbs up or higher" },
          { rating: 0.5, text: "50% Thumbs up or higher" },
        ].map((rate) => (
          <option key={`thumbs-${rate.rating}`} value={`thumbs-${rate.rating}`}>
            {rate.text}
          </option>
        ))
      : "";
    const TensRatings = this.state.tensRatingUsed
      ? [
          { rating: 10, text: "10 Points" },
          { rating: 9, text: "9 or greater" },
          { rating: 8, text: "8 or greater" },
          { rating: 7, text: "7 or greater" },
          { rating: 6, text: "6 or greater" },
          { rating: 5, text: "5 or greater" },
          { rating: 4, text: "4 or greater" },
          { rating: 3, text: "3 or greater" },
          { rating: 2, text: "2 or greater" },
          { rating: 1, text: "1 or greater" },
        ].map((rate) => (
          <option key={`tens-${rate.rating}`} value={`tens-${rate.rating}`}>
            {rate.text}
          </option>
        ))
      : "";

    const disabledDaysAfterDateFrom =
      !this.state.formData.toDate ||
      this.state.formData.toDate === "Invalid Date" ||
      this.state.formData.toDate === "0000-00-00"
        ? new Date()
        : accountForExistingTimeOffset(this.state.formData.toDate);

    const disabledDaysBeforeDateTo =
      this.state.formData.fromDate &&
      this.state.formData.fromDate !== "Invalid Date" &&
      this.state.formData.fromDate !== "0000-00-00"
        ? accountForExistingTimeOffset(this.state.formData.fromDate)
        : null;

    const Body = (
      <>
        <span className="advanced-search-title">Advanced Search</span>
        <Form className="advanced-search-filter-form mt-3 mb-0">
          <Row className="advanced-search-text-input">
            <Col lg={6} md={6} sm={12}>
              <FormGroup>
                <FormControl
                  type="text"
                  name="candidateName"
                  value={
                    this.state.formData.searchText === null
                      ? ""
                      : this.state.formData.searchText
                  }
                  placeholder="Search"
                  onChange={this.handleSearchInput}
                />
                <FormLabel id="search-input-text">
                  Candidate Name, Email, Event ID, or Confirmation Number
                </FormLabel>
              </FormGroup>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col className="advanced-search-title-container">
              <h4>Job</h4>
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={12}>
              <FormGroup>
                <FormLabel className="advanced-search-input-labels">
                  Title
                </FormLabel>
                <FormControl
                  as="select"
                  id="jobTitle"
                  value={this.state.formData.jobTitle}
                  onChange={this.handleSelection}
                >
                  <option value="">Choose a Job Title</option>
                  {Titles}
                </FormControl>
              </FormGroup>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <FormGroup>
                <FormLabel className="advanced-search-input-labels">
                  Location
                </FormLabel>
                <FormControl
                  as="select"
                  id="location"
                  value={this.state.locationSelected}
                  onChange={this.handleSelection}
                >
                  <option value="">Choose a Location</option>
                  {Locations}
                </FormControl>
              </FormGroup>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <FormGroup>
                <FormLabel className="advanced-search-input-labels">
                  Application Filter
                </FormLabel>
                <FormControl
                  as="select"
                  id="application"
                  value={this.state.formData.applicationFilterId}
                  onChange={this.handleSelection}
                >
                  <option value="">Choose an Application Filter</option>
                  {ApplicationFilters}
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col className="advanced-search-title-container">
              <h4>Candidate</h4>
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={12}>
              <FormGroup>
                <FormLabel className="advanced-search-input-labels">
                  Applied
                </FormLabel>
                <br />
                <DatePickerInput
                  handleDateChange={this.handleFromDateChange}
                  dateValue={
                    !this.state.formData.fromDate ||
                    this.state.formData.fromDate === "Invalid Date" ||
                    this.state.formData.fromDate === "0000-00-00"
                      ? ""
                      : this.state.formData.fromDate
                  }
                  disabled={{
                    after: disabledDaysAfterDateFrom,
                  }}
                />
                <FormLabel style={{ padding: "0 6px" }}>to</FormLabel>
                <DatePickerInput
                  handleDateChange={this.handleToDateChange}
                  dateValue={
                    !this.state.formData.toDate ||
                    this.state.formData.toDate === "Invalid Date" ||
                    this.state.formData.toDate === "0000-00-00"
                      ? ""
                      : this.state.formData.toDate
                  }
                  disabled={{
                    after: new Date(),
                    before: disabledDaysBeforeDateTo,
                  }}
                />
                <ClearDatesButton handleClearDates={this.handleClearDates} />
              </FormGroup>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <FormGroup>
                <FormLabel className="advanced-search-input-labels">
                  Stage
                </FormLabel>
                <FormControl
                  as="select"
                  id="stageName"
                  value={this.state.formData.stageName}
                  onChange={this.handleSelection}
                >
                  <option value="">Choose an Stage</option>
                  <option key="hired" value="hired">
                    Hired
                  </option>
                  <option key="incoming" value="incoming">
                    Incoming
                  </option>
                  <option key="on Hold" value="on Hold">
                    On Hold
                  </option>
                  <option key="rejected" value="rejected">
                    Rejected
                  </option>
                  <option key="withdrawn" value="withdrawn">
                    Withdrawn
                  </option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <FormGroup>
                <FormLabel className="advanced-search-input-labels">
                  Rating
                </FormLabel>
                <FormControl
                  as="select"
                  id="ratings"
                  value={`${this.state.formData.ratingType}-${this.state.formData.ratingValue}`}
                  onChange={this.handleSelection}
                >
                  <option value="">Choose a Rating</option>
                  {StarRatings}
                  {TensRatings}
                  {ThumbsRatings}
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={12}>
              <FormGroup>
                <FormLabel className="advanced-search-input-labels">
                  Source
                </FormLabel>
                <FormControl
                  as="select"
                  id="sources"
                  value={this.state.formData.sourceId}
                  onChange={this.handleSelection}
                >
                  <option value="">Choose a Source</option>
                  {Sources}
                </FormControl>
              </FormGroup>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <FormGroup>
                <FormLabel className="advanced-search-input-labels">
                  Label
                </FormLabel>
                <FormControl
                  as="select"
                  id="labels"
                  value={this.state.formData.labelId}
                  onChange={this.handleSelection}
                >
                  <option value="">Choose a Label</option>
                  {Labels}
                </FormControl>
              </FormGroup>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <FormGroup>
                <FormLabel className="advanced-search-input-labels">
                  Event Status
                </FormLabel>
                <FormControl
                  as="select"
                  id="eventStatus"
                  value={this.state.formData.eventStatus}
                  onChange={this.handleSelection}
                >
                  <option value="">Choose a Test Status</option>
                  <option key="complete" value="Complete">
                    Complete
                  </option>
                  <option key="disqualified" value="Disqualified">
                    Disqualified
                  </option>
                  <option key="inProgress" value="InProgress">
                    In Progress
                  </option>
                  <option key="invited" value="Invited">
                    Invited
                  </option>
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <Row className="testTakerId-input">
            <Col lg={4} md={4} sm={12}>
              <FormGroup>
                <FormLabel className="advanced-search-input-labels">
                  Test Taker ID
                </FormLabel>
                <FormControl
                  type="text"
                  name="testTakerId"
                  value={this.state.formData.testTakerId}
                  placeholder="Test Taker ID"
                  onChange={this.handleTestTakerIdInput}
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
        <hr />
        <Row>
          <Col>
            <button
              type="button"
              className="btn btn-as-link text-left"
              onClick={this.handleClearSearch}
              id="clearSearch"
            >
              Clear Search
            </button>
          </Col>
          <Col className="text-right">
            <Button
              onClick={this.hideSearchModal}
              id="cancelSearch"
              variant="outline-primary"
              className="btn-cancel"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={this.onHandleFilteredSearchSubmit}
              id="doSearch"
            >
              Search
            </Button>
          </Col>
        </Row>
      </>
    );

    return !isMobile ? (
      <Modal show dialogClassName="search-modal" onHide={this.hideSearchModal}>
        <Modal.Body>{Body}</Modal.Body>
      </Modal>
    ) : (
      Body
    );
  }
}

SearchFilterModal.propTypes = {
  searchFilterOptions: object.isRequired,
  searchFilters: object,
  hideSearchModal: func.isRequired,
  handleFilteredSearchSubmit: func.isRequired,
  onSetUserInput: func.isRequired,
  currentSearchText: string,
  onResetSearchFilters: func.isRequired,
  isMobile: bool,
};

export default SearchFilterModal;
